"use strict";

exports.__esModule = true;
exports.getReferenceField = exports.getReferenceSchema = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const getReferenceSchema = props => {
  const schema = props.schema;
  const documentType = schema.documentType,
        referenceType = schema.referenceType,
        _reverseReferenceType = schema._reverseReferenceType,
        _reverseReference = schema._reverseReference; // default schema

  let defaultSchema = {
    "type": "object",
    "properties": {
      "referenceId": {
        "type": "string",
        "readonly": true
      },
      "referenceType": {
        "type": "string",
        "default": undefined,
        "readonly": true
      },
      "reference": {
        "type": "object",
        "properties": {
          "uniqueId": {
            "type": "string",
            "default": undefined,
            "readonly": true
          },
          "documentType": {
            "type": "string",
            "default": undefined,
            "readonly": true
          },
          "title": {
            "type": "string",
            "default": "Untitled"
          },
          "_action": {
            "type": "string",
            "readonly": true,
            "default": "update"
          }
        }
      },
      "_action": {
        "type": "string",
        "readonly": true,
        "default": "update"
      }
    }
  }; // referenceType

  if (referenceType) {
    defaultSchema = _extends({}, defaultSchema, {
      properties: _extends({}, defaultSchema.properties, {
        referenceType: _extends({}, defaultSchema.properties.referenceType, {
          default: referenceType
        })
      })
    });
  } // reference


  if (documentType) {
    let defaultType, defaultEnum;

    if (Array.isArray(documentType)) {
      defaultType = documentType[0];
      defaultEnum = documentType;
    } else {
      defaultType = documentType;
    }

    defaultSchema = _extends({}, defaultSchema, {
      properties: _extends({}, defaultSchema.properties, {
        reference: _extends({}, defaultSchema.properties.reference, {
          properties: _extends({}, defaultSchema.properties.reference.properties, {
            documentType: _extends({}, defaultSchema.properties.reference.properties.documentType, {
              default: defaultType,
              enum: defaultEnum
            }),
            title: _extends({}, defaultSchema.properties.reference.properties.title, {
              default: "Untitled " + defaultType
            })
          })
        })
      })
    });
  } // _reverseReferenceType


  if (_reverseReferenceType) {
    defaultSchema = _extends({}, defaultSchema, {
      properties: _extends({}, defaultSchema.properties, {
        _reverseReferenceType: {
          "type": "string",
          "default": _reverseReferenceType,
          "readonly": true
        }
      })
    });
  } // _reverseReference


  if (_reverseReference) {
    defaultSchema = _extends({}, defaultSchema, {
      properties: _extends({}, defaultSchema.properties, {
        _reverseReference: {
          "type": "string",
          "default": _reverseReference,
          "readonly": true
        }
      })
    });
  } // properties


  if (schema.properties) {
    defaultSchema = _extends({}, defaultSchema, {
      properties: _extends({}, defaultSchema.properties, {}, schema.properties)
    });
  }

  return defaultSchema;
};

exports.getReferenceSchema = getReferenceSchema;

const getReferenceField = props => {
  const schema = getReferenceSchema(props);
  return _extends({}, props, {
    schema: schema,
    uiSchema: _extends({}, props.uiSchema, {
      "ui:field": "reference"
    })
  });
};

exports.getReferenceField = getReferenceField;